import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Mail, Phone, MapPin } from "lucide-react";
import { CONTACT } from "@/data/content";
import { Reveal } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", company: "", message: "" });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast.error("Lütfen ad ve e-posta alanlarını doldurun.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/demo-requests`, { ...form, plan: "" });
      toast.success("Talebiniz alındı. En kısa sürede dönüş yapacağız.");
      setForm({ name: "", email: "", company: "", message: "" });
    } catch (err) {
      toast.error("Bir hata oluştu. Lütfen tekrar deneyin.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="relative border-t border-white/10 py-28 md:py-40" data-testid="contact">
      <div className="ec-container grid grid-cols-1 gap-14 lg:grid-cols-2">
        <Reveal>
          <p className="ec-eyebrow mb-4">
            <span className="h-1.5 w-1.5 rounded-full bg-[#D4F870]" />
            İLETİŞİM
          </p>
          <h2 className="font-display text-4xl leading-[1.02] tracking-tight text-[#F3F4F6] sm:text-5xl md:text-6xl">
            Demo talep et,<br />30 dakikada başla.
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-[#9CA3AF]">
            Ekibimiz Carbon Ledger'ı işletmene nasıl uyarlayacağını göstersin.
          </p>

          <div className="mt-10 space-y-5">
            <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-4 text-[#F3F4F6] transition-colors hover:text-[#D4F870]" data-testid="contact-email">
              <span className="grid h-10 w-10 place-items-center rounded-full border border-white/10"><Mail className="h-4 w-4" /></span>
              {CONTACT.email}
            </a>
            <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="flex items-center gap-4 text-[#F3F4F6] transition-colors hover:text-[#D4F870]" data-testid="contact-phone">
              <span className="grid h-10 w-10 place-items-center rounded-full border border-white/10"><Phone className="h-4 w-4" /></span>
              {CONTACT.phone}
            </a>
            <div className="flex items-center gap-4 text-[#9CA3AF]">
              <span className="grid h-10 w-10 place-items-center rounded-full border border-white/10"><MapPin className="h-4 w-4" /></span>
              {CONTACT.address}
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <form
            onSubmit={submit}
            className="rounded-2xl border border-white/10 bg-[#121212] p-7 md:p-9"
            data-testid="contact-form"
          >
            <div className="space-y-5">
              <Field label="Ad Soyad *" value={form.name} onChange={update("name")} testId="contact-name" placeholder="Adınız" />
              <Field label="E-posta *" type="email" value={form.email} onChange={update("email")} testId="contact-email-input" placeholder="ornek@sirket.com" />
              <Field label="Şirket" value={form.company} onChange={update("company")} testId="contact-company" placeholder="Şirket adı" />
              <div>
                <label className="mb-2 block text-xs uppercase tracking-widest text-[#9CA3AF]">Mesaj</label>
                <textarea
                  value={form.message}
                  onChange={update("message")}
                  rows={4}
                  placeholder="İhtiyacını kısaca anlat"
                  data-testid="contact-message"
                  className="w-full resize-none rounded-xl border border-white/10 bg-[#0A0A0A] px-4 py-3 text-sm text-[#F3F4F6] outline-none transition-colors placeholder:text-[#4B5563] focus:border-[#D4F870]/60"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                data-testid="contact-submit"
                className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#D4F870] px-7 py-3.5 text-sm font-medium text-[#0A0A0A] transition-colors hover:bg-[#BEF264] disabled:opacity-60"
              >
                {loading ? "Gönderiliyor..." : "Demo Talep Et"}
                {!loading && <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />}
              </button>
            </div>
          </form>
        </Reveal>
      </div>
    </section>
  );
};

const Field = ({ label, type = "text", value, onChange, placeholder, testId }) => (
  <div>
    <label className="mb-2 block text-xs uppercase tracking-widest text-[#9CA3AF]">{label}</label>
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      data-testid={testId}
      className="w-full rounded-xl border border-white/10 bg-[#0A0A0A] px-4 py-3 text-sm text-[#F3F4F6] outline-none transition-colors placeholder:text-[#4B5563] focus:border-[#D4F870]/60"
    />
  </div>
);
